<section class="category-description-box prose" id="full-search-description">
  @if (name() && place()) {
    <div class="description">
      <!-- This whole part is to be shown when there is at least 2 reviews or more -->
      @if (totalNumberOfRatings() > 1) {
        <h2>
          Vad har {{ pluralName() | lowercase }} i {{ place() }} för snittbetyg?
        </h2>
        <p>
          I {{ place() }} ligger snittbetyget för
          {{ pluralName() | lowercase }} på
          <span class="bold">{{
              data()?.averageRating | number : '1.0-2'
            }}</span
          >, vilket är
          <span class="bold">{{
              data()?.averageRating < data()?.totalAverageRating
                ? 'sämre'
                : 'bättre'
            }}</span>
          än i resten av landet. Vad tycker du om din {{ name() | lowercase }}?
          Lämna gärna ett omdöme! Det tar bara några få sekunder. Genom att
          lämna ett omdöme hjälper du andra patienter att hitta rätt vård och
          bidrar till större transparens och öppenhet kring olika vårdgivare
          och {{ pluralName() | lowercase }} i {{ place() }}.
        </p>

        <div itemscope itemtype="https://schema.org/FAQPage">
          <div
            itemprop="mainEntity"
            itemscope
            itemtype="https://schema.org/Question"
          >
            <h2 itemprop="name">
              Vilken {{ name() | lowercase }} är bäst i {{ place() }}?
            </h2>
            <div
              itemprop="acceptedAnswer"
              itemscope
              itemtype="https://schema.org/Answer"
            >
              <p itemprop="text">
                Att välja vilken {{ name() | lowercase }} i {{ place() }} du ska gå
                till är inte alltid ett självklart beslut. Det är viktigt att du
                känner dig trygg med den vårdgivare du väljer. Därför hjälper vi
                dig jämföra {{ pluralName() | lowercase }} baserat på vad deras
                patienter faktiskt tycker.
                <!-- The following message is to be shown for Vardcentral care type only. -->
                @if (searchResultContent()?.caregiverUnitType?.urlPath === 'vardcentral') {
                  Vi utgår ifrån betyg som patienterna själva satt och Nationella
                    patientenkäten.
                }
              </p>
            </div>
          </div>
        </div>

        @if (data()?.topRatedCareProviderUnits?.length) {
          <h2>Snittbetyg enligt patientomdömen på Vården.se</h2>
          <p>
            De {{ pluralName() | lowercase }} med bästa snittbetyg i {{ place() }} på
            Vården.se är:
          </p>
          <ul class="top-rated-units">
            @for (careProviderUnit of data().topRatedCareProviderUnits; track careProviderUnit.linkUrl) {
              <li>
                <a [routerLink]="[careProviderUnit.linkUrl]">
                  {{ careProviderUnit.careProviderName }}
                </a>
                ({{ careProviderUnit.rating | number : '1.0-2' }} av 5 - baserat på
                {{ careProviderUnit.basedOnNumberOfRatings }} omdömen)
              </li>
            }
          </ul>
        }

      } @else {
        <h2>
          Vad har {{ pluralName() | lowercase }} i {{ place() }} för snittbetyg?
        </h2>
        <p>
          I nuläget finns det inga omdömen på {{ name() | lowercase }} i
          {{ place() }}. Lämna gärna ett omdöme om just din
          {{ name() | lowercase }} i {{ place() }} så att fler patienter kan hitta
          rätt vård!
        </p>

        <h2>
          Vilken {{ pluralName() | lowercase }} är bäst i {{ place() }}?
        </h2>
        <p>
          Eftersom det inte finns några omdömen på
          {{ pluralName() | lowercase }} i {{ place() }} idag så är det svårt att
          säga vilken som är bäst. Du kan till exempel jämföra öppettider
          eller adress, för att se vilken {{ pluralName() | lowercase }} som
          passar bäst för just dig.
        </p>
      }




      <!-- What others say. Comments. -->
      @if (data()?.latestReviews?.length) {
        <h2>Så tycker patienter om {{ pluralName() | lowercase }} i {{ place() }}</h2>
        <ul class="latest-reviews">
          @for (review of data().latestReviews; track review.linkUrl) {
            <li class="review-item">
              <p>
                <q>{{ review.comment }}</q>
              </p>
              <p>
                <span>&ndash;&nbsp;</span>
                <span>{{
                    review.firstname +
                    (review.lastname ? ' ' + review.lastname[0] + '.' : '')
                  }}</span>
                <span>&comma;&nbsp;</span>
                <span>
                  <a [routerLink]="[review.linkUrl]">
                    {{ review.careProviderName }}
                  </a>
                </span>
              </p>
            </li>
          }
        </ul>
      }


      <!-- National Patient Survey. To be shown for Vardcentral care type only. -->
      @if (searchResultContent()?.caregiverUnitType?.urlPath === 'vardcentral' &&
      data()?.npeSurveyResults?.length) {

        <h2>
          Bästa {{ pluralName() | lowercase }} utifrån Nationella Patientenkäten
        </h2>
        <p>
          Varje år genomförs en enkät bland alla patienter i Sverige för att
          utvärdera {{ pluralName() | lowercase }} runt om i landet, på uppdrag av
          Sveriges Kommuner och Regioner. Resultaten från 2021 visade att dessa
          {{ pluralName() | lowercase }} i {{ place() }}
          var bäst på följande:
        </p>
        <ul class="survey-results">
          @for (surveyResult of data().npeSurveyResults; track surveyResult.linkUrl) {
            <li>
              <span> {{ surveyResult.name }}: </span>
              <a [routerLink]="[surveyResult.linkUrl]">
                {{ surveyResult.careProviderUnit }}
              </a>
            </li>
          }
        </ul>
      }


      <!-- Soonest available services -->
      @if (data()?.soonerTimeSlotsCareProviderUnits?.length) {
        <h2>
          De {{ pluralName() | lowercase }} i {{ place() }}
          som erbjuder tid snabbast är:
        </h2>
        <ul class="soonest-available">
          @for (careProvider of data().soonerTimeSlotsCareProviderUnits; track careProvider.linkUrl) {
            <li class="soonest-available-item">
              <a [routerLink]="careProvider.linkUrl">
                {{ careProvider.careProviderName }}
              </a>
            </li>
          }
        </ul>
      }


      <!-- Opening hours -->
      <h2>
        Vilka {{ pluralName() | lowercase }} i {{ place() }}
        har öppet på kvällar och helger?
      </h2>
      @if (data()?.openHours?.length) {
        <p>
          Om du behöver hjälp på kvällen eller helgen kan du vända dig till
          någon av dessa {{ pluralName() | lowercase }}:
        </p>
      } @else {
        <p>
          Idag finns det inga {{ pluralName() | lowercase }} i {{ place() }}
          som har öppet på kvällar eller helger. Om du vill nå en
          {{ name() | lowercase }} på kvällen eller på helgen kan du prova att utöka
          din sökning på Vården.se.
        </p>
      }
      @if (data() && data().openHours) {
        <ul class="open-hours">
          @for (careProvider of data().openHours; track careProvider.linkUrl) {
            <li class="open-hours-item">
              <a [routerLink]="careProvider.linkUrl">
                {{ careProvider.careProviderName }}
              </a>
              <br>
              <span>
                  {{ careProvider.fromDay | day }} -
                {{ careProvider.toDay | day }} kl
                {{ careProvider.fromTime | hour }} -
                {{ careProvider.toTime | hour }}
                    </span>
              <div>{{ careProvider.comment }}</div>
            </li>
          }
        </ul>
      }

      <!-- Services with listing available -->
      @if (data()?.listingsCareProviderUnits?.length) {
        <h2>Vill du välja {{ name() | lowercase }} i {{ place() }}?</h2>
        <p>
          Idag så kan du som patient lista dig på en {{ name() | lowercase }} i
          {{ place() }}. Det betyder helt enkelt att du kan få kontinuerlig hjälp
          med vård och hälsa. På Vården.se kan du lista dig online på följande
          {{ name() | lowercase }} i {{ place() }}:
        </p>
        <ul class="with-listing">
          @for (careProvider of data().listingsCareProviderUnits; track careProvider.linkUrl) {
            <li class="with-listing-item">
              <a [routerLink]="careProvider.linkUrl">
                {{ careProvider.careProviderName }}
              </a>
            </li>
          }
        </ul>
      }
    </div>
  }

  <!-- Additional description -->
  <div
    [innerHTML]="searchDescription().description"
    class="category-description-content"
  ></div>
</section>
